module.exports = __webpack_public_path__ + "static/media/infiniti-headset.20b6ab71.svg";